import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GetVideo } from "../../../../Api/Video";
import { RoutePaths } from "../../../../Constants/RoutePaths";
import VideoDTO from "../../../../Models/DTOs/VideoDTO";

export default function ArticleVideoCard({ id }: { id: number }) {
    const [video, setVideo] = useState<VideoDTO | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const controller = new AbortController();
        setVideo(null);
        setLoading(true);
        GetVideo(id, controller)
            .then((result) => {
                // Admin sessions can see unpublished records through the same API.
                // Article cards should not expose archived video metadata.
                if (!controller.signal.aborted && result.Id === id && result.AccessLevel > 0) {
                    setVideo(result);
                }
            })
            .catch(() => { /* Missing, restricted and failed cards share a safe fallback. */ })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });
        return () => controller.abort();
    }, [id]);

    if (loading) {
        return <span className="article-card article-card--placeholder" role="status">Loading video...</span>;
    }
    if (!video) {
        return <span className="article-card article-card--placeholder">This video is currently unavailable.</span>;
    }

    // The normal player route retains playback access checks. Phrasing elements
    // keep cards valid even inside a legacy paragraph or emphasis tag.
    return (
        <span className="article-card article-card--video">
            <Link to={RoutePaths.Watch(video.Id)} className="article-card__link">
                {video.Thumbnail && <img src={video.Thumbnail} alt="" loading="lazy" />}
                <span className="article-card__details">
                    <span className="article-card__label">Video</span>
                    <strong>{video.Title || "Watch video"}</strong>
                    <span className="article-card__action">View video</span>
                </span>
            </Link>
        </span>
    );
}
